import { render, staticRenderFns } from "./payeeBill.vue?vue&type=template&id=24cdd2b1&scoped=true&"
import script from "./payeeBill.vue?vue&type=script&lang=js&"
export * from "./payeeBill.vue?vue&type=script&lang=js&"
import style0 from "./payeeBill.vue?vue&type=style&index=0&id=24cdd2b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cdd2b1",
  null
  
)

export default component.exports